module.exports = __webpack_public_path__ + "img/logo.4d775aa4.png";